import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
// import { ManageLibraryComponent } from '../../../../../manage-library/manage-library.component';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { ManageLibraryComponent } from 'vhobjects-service';
import { FunctionService } from 'vhobjects-service/src/services';
import { LanguageService } from 'vhobjects-service/src/services';
import { EditShapeComponent } from './../edit-shape/edit-shape.component';

@Component({
  selector: 'atw-shape-config',
  templateUrl: './shape-config.component.html',
  styleUrls: ['./shape-config.component.scss']
})
export class AtwShapeConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any; // xác định trang ở page hay preview

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  dataAfterChange: any = {} // lưu tên và style data để cập nhật vào database.
  currentViewAll: any = {};
  imgAddress: string = ''; // biến để lưu address image
  nameFileImg: string = ''; // biến để lưu tên file image
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  backgroundColor: any = [];

  // checkedRemoveShape: boolean = false;
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false
  };
  styles_field = [
    {
      title: 'nang_cao',
      index: 0,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
  ];
  // Các dạng hình dạng
  clipPaths: any = [
    {
      id: 1,
      name: 'square-default',
      clipPath: 'inset(0%)'
    },
    {
      id: 2,
      name: 'circle',
      clipPath: 'circle(35% at 50% 50%)',
    },
    {
      id: 3,
      name: 'triangle',
      clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    },
    {
      id: 4,
      name: 'diamond',
      clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
    },
    {
      id: 5,
      name: 'pentagon',
      clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
    },
    {
      id: 6,
      name: 'rabbet',
      clipPath: 'polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%)',
    },
    {
      id: 7,
      name: 'left-arrow',
      clipPath: 'polygon(0% 50%, 50% 0%, 50% 25%, 100% 25%, 100% 75%, 50% 75%, 50% 100%)',
    },
    {
      id: 8,
      name: 'right-arrow',
      clipPath: 'polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)',
    },
    {
      id: 9,
      name: 'left-point',
      clipPath: 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)',
    },
    {
      id: 10,
      name: 'right-point',
      clipPath: 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)',
    },
    {
      id: 11,
      name: 'left-chevron',
      clipPath: 'polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)',
    },
    {
      id: 12,
      name: 'right-chevron',
      clipPath: 'polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)',
    },
    {
      id: 13,
      name: 'message',
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%)',
    },
    {
      id: 14,
      name: 'unknown_1',
      clipPath: 'polygon(0% 0%, 58% 0%, 100% 100%, 0% 100%)'
    },
    {
      id: 15,
      name: 'unknown_2',
      clipPath: 'polygon(0% 0%, 100% 0%, 58% 100%, 0% 100%)'
    },
    {
      id: 16,
      name: 'unknown_3',
      clipPath: 'polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%)'
    },
    {
      id: 17,
      name: 'unknown_4',
      clipPath: 'polygon(0% 0%, 80% 0%, 100% 100%, 0% 100%)'
    },
    {
      id: 18,
      name: 'unknown_5',
      clipPath: 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)'
    },
    {
      id: 19,
      name: 'unknown_6',
      clipPath: 'polygon(0% 0%, 100% 50%, 0% 100%, 25% 50%)'
    },
    {
      id: 20,
      name: 'square-outline',
      clipPath: 'polygon(0% 0%, 0% 100%, 25% 100%, 25% 25%, 75% 25%, 75% 75%, 25% 75%, 25% 100%, 100% 100%, 100% 0%)'
    },
    {
      id: 21,
      name: 'square-outline-2',
      clipPath: 'polygon(0% 0%, 0% 100%, 1px 100%, 1px 1px, calc(100% - 1px) 1px, calc(100% - 1px) calc(100% - 1px), 0 calc(100% - 1px), 0 100%, 100% 100%, 100% 0%)'
    },
    {
      id: 22,
      name: 'star',
      clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)'
    },
    {
      id: 23,
      name: 'ellipse',
      clipPath: 'ellipse(25% 50% at 50% 50%)'
    },
    {
      id: 24,
      name: 'ellipse',
      clipPath: 'ellipse(50% 25% at 50% 50%)'
    }
  ];
  //Kiểu độ bao phủ
  style_cover = [
    {
      name: 'unset',
      title: 'Mặc định',
      image: '../../../../../../../assets/root/images/system/imgs/object-fit-default.jpg'
    },
    {
      name: 'cover',
      title: 'Bao phủ',
      image: '../../../../../../../assets/root/images/system/imgs/object-fit-cover.jpg'
    },
    {
      name: 'contain',
      title: 'Vừa vặn',
      image: '../../../../../../../assets/root/images/system/imgs/object-fit-contain.jpg'
    },
  ]

  effect_hover = [];
  effect_hover_data: any = {};
  customize = [];

  previewUploadUrl: string | null = null; // url preview trong vùng kéo thả
  dragging = false; // biến kiểm tra người dùng dùng rời con trỏ khỏi vùng upload mà chưa thả
  compressWidth: number = 100;
  compressHeight: number = 100;
  resolution = null;
  id_subproject: any;
  subproject = null;
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private vhImage: VhImage,
    private vhEventMediator: VhEventMediator,
    private matdialog: MatDialog,
    private matDialog: MatDialog,
    public functionService: FunctionService,
    private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
    this.resolution = this.subproject.resolution;

    if (!this.objectChoosing?.hasOwnProperty('setups')) {
      this.objectChoosing.setups = {
        "upload_image": {
          "display": "shared",
          "compress_type": "compress-screen",
          "source": "device"
        }
      };
    }

    // Kiểm tra nếu background_restore đã là màu thì gán lại chống lỗi
    if (this.isValidColor(this.config.background_restore) && !this.config.hasOwnProperty('background_color_restore')) {
      this.config.background_color_restore = this.config.background_restore;
    }

    if (!this.config.hasOwnProperty('background_color_restore')) {
      this.config.background_color_restore = 'rgb(77, 138, 198)';
    }
    
    if (!this.config.hasOwnProperty('background_image_restore')) {
      this.config.background_image_restore = "https://img.freepik.com/free-photo/green-field-tree-blue-skygreat-as-backgroundweb-banner-generative-ai_1258-153069.jpg";
    }

    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/data/effects/shape.json'),
    ]).subscribe(([background_colors, effects]: any) => {
      this.backgroundColor = background_colors;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
    })
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[1])
  }


  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      })
  }
  /**
  * Cập nhật staticdata vào database.
  */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {

      });
  }

  /**
   * Xử lý hình dạng của nút bấm
   * @param item : trả về mẫu hình dạng được chọn
   * @param e : trả về element được active
   */
  chooseItem(item, event) {
    // Get class active của element khi click chọn hướng phối màu.
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    if (isPlatformBrowser(this.platformId)) {
      const variants_shape = this.class.shape__parent;

      this.class.shape__parent['clip-path'] = item.clipPath
      this.class.shape__child['clip-path'] = item.clipPath
      // variants_shape.clip_path = item.clipPath;
      variants_shape.name = item.name;
      this.updateClass();
    }
  }

  /** Xử lý chọn màu thông thường hoặc đa màu
   * @param tone: tên màu được chọn
   */
  handleToneBackground(tone) {
    this.config.toggle_tone = tone;
    this.config.background_rbga_restore = `linear-gradient(${this.class.shape__child.direction}, ${this.config.color_gradient_1}, ${this.config.color_gradient_2})`;
    this.config.background_restore = this.class.shape__child.background;
    // const bgRbgaRestore = this.config.background_rbga_restore;
    if (tone !== 'Bình thường') {
      this.class.shape__child.background = this.config.background_rbga_restore;
    }
    else {
      this.class.shape__child.background = this.config.background_restore;
    }
    this.updateClass();
  }

  /**
   * Xử lý chọn background-cover khi thêm hình ảnh vào hình dạng
   * @param option : trả về background-cover được chọn
   * @param e : trả về element được active
   */
  chooseOptionCover(option, e) {
    // Get class active của element khi click chọn hướng phối màu.
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    const backgroundCover = this.class.shape__child
    this.config.option = option.name
    backgroundCover['background-size'] = option.name
    this.updateConfig();
    this.updateClass();
  }

  /**
   * Xử lý kích hoạt chọn thêm màu cho hình dạng
   */
  handleChangeBackgroundColor() {
    const backgroundShape = this.class.shape__child;
    const config = this.config;
    this.config.background_rbga_restore = this.class.background;
    if (config.switchColor == true) {
      config.switch_image = false;
      backgroundShape.background = backgroundShape.background;
    }
    else {
      backgroundShape['background'] = "url('https://img.freepik.com/free-photo/green-field-tree-blue-skygreat-as-backgroundweb-banner-generative-ai_1258-153069.jpg')"
      config.switch_image = true;
    }
    this.updateConfig()
    this.updateClass()
  }

  /**
 * Xử lý kích hoạt chọn đổ bóng
 */
  handleChangeBoxShadow() {
    const boxShadow = this.config;
    boxShadow.switchShadow = boxShadow.switchShadow;
    this.updateConfig();
  }

  /**
   * Xử lý kích hoạt chọn thêm hình ảnh cho hình dạng
   */
  handleChangeBackgroundImage() {
    this.config.background_restore = this.class.shape__child.background;  //biến tạm lưu bg Color trước khi thay đổi
    const storageBgColor = this.config.background_restore
    const backgroundShape = this.class.shape__child
    if (this.config.switch_image == true) {
      this.config.switchColor = false;
      backgroundShape['background'] = "url('https://img.freepik.com/free-photo/green-field-tree-blue-skygreat-as-backgroundweb-banner-generative-ai_1258-153069.jpg')"
      backgroundShape.background = storageBgColor
    }
    else {
      this.config.switchColor = true;
      backgroundShape.background = storageBgColor
    }
    this.updateObject()
  }

  /**
   * Xử lý lấy image address để hiển thị
   * @param e : trả về đường dẫn ảnh
   */
  handleImageAddress(e) {
    // nhận địa chỉ đường dẫn ảnh bên ngoài web từ tham số e trả về
    const backgroundShape = this.config.background_image_restore
    // this.imgAddress = e.target.value;
    // backgroundShape['background'] = "url(" + this.imgAddress + ")";
    if (this.config.background_image_restore.includes(this.id_subproject)) {
      this.handleSetBackgroundImage();
    } else {

    }
    this.updateObject();
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
  * Hàm update object vào database.
  */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }


  /**
   * Hàm này thay đổi box-shadow giữa có hiệu ứng và không có hiệu ứng.
   * Khi gọi hàm này thì hiệu ứng hover hiển thị box-shadow sẽ bị disable.
   * Ngược lại thì thì hiệu ứng hover hiển thị box-shadow enable.
   * @param event : trả về giá trị true false
   */
  onChangeShadow(e) {
    // Lấy giá trị true false của tham số event
    var shadow = this.class['shape']
    var config = this.config['box-shadow']
    // Khi giá trị trả về false, set style box-shadow về mặc định.
    // Khi giá trị trả về true, set style box-shadow theo giá trị đã thay đổi trước đó.
    if (e === false) {
      shadow['box-shadow'] = `0px 0px 0px #333`;
    } else {
      shadow['box-shadow'] = `${config.offset_x}px ${config.offset_y}px ${config.blur_radius}px ${config.shadow_color}`;
    }
  }

  //Lật hình
  handleSetTransform(axis) {
    switch (axis) {
      case 'x':       // ---Lật dọc
        if (this.config.transform.rotateX < 360) {
          this.config.transform.rotateX += 180;
          this.class.shape__parent.transform = "rotateX(" + this.config.transform.rotateX + "deg)"
            + "rotateY(" + this.config.transform.rotateY + "deg)"
            + "rotateZ(" + this.config.transform.rotateZ + "deg)"
            + "skewX(" + this.config.transform.skewX + "deg)"
            + "skewY(" + this.config.transform.skewY + "deg)"
        }
        else
          this.config.transform.rotateX -= 180;
        this.class.shape__parent.transform = "rotateX(" + this.config.transform.rotateX + "deg)"
          + "rotateY(" + this.config.transform.rotateY + "deg)"
          + "rotateZ(" + this.config.transform.rotateZ + "deg)"
          + "skewX(" + this.config.transform.skewX + "deg)"
          + "skewY(" + this.config.transform.skewY + "deg)"
        break;
      case 'y':       // ---Lật ngang
        if (this.config.transform.rotateY < 360) {
          this.config.transform.rotateY += 180;
          this.class.shape__parent.transform = "rotateX(" + this.config.transform.rotateY + "deg)"
            + "rotateY(" + this.config.transform.rotateY + "deg)"
            + "rotateZ(" + this.config.transform.rotateZ + "deg)"
            + "skewX(" + this.config.transform.skewX + "deg)"
            + "skewY(" + this.config.transform.skewY + "deg)"
        }
        else {
          this.config.transform.rotateY -= 180;
          this.class.shape__parent.transform = "rotateX(" + this.config.transform.rotateX + "deg)"
            + "rotateY(" + this.config.transform.rotateY + "deg)"
            + "rotateZ(" + this.config.transform.rotateZ + "deg)"
            + "skewX(" + this.config.transform.skewX + "deg)"
            + "skewY(" + this.config.transform.skewY + "deg)"
        }
        break;
      case '-z':        // --- Xoay trái
        if (this.config.transform.rotateZ > -360) {
          this.config.transform.rotateZ -= 90;
          this.class.shape__parent.transform = "rotateX(" + this.config.transform.rotateX + "deg)"
            + "rotateY(" + this.config.transform.rotateY + "deg)"
            + "rotateZ(" + this.config.transform.rotateZ + "deg)"
            + "skewX(" + this.config.transform.skewX + "deg)"
            + "skewY(" + this.config.transform.skewY + "deg)"
        }
        break;
      case 'z':         // --- Xoay phải
        if (this.config.transform.rotateZ < 360)
          this.config.transform.rotateZ += 90;
        this.class.shape__parent.transform = "rotateX(" + this.config.transform.rotateX + "deg) "
          + "rotateY(" + this.config.transform.rotateY + "deg) "
          + "rotateZ(" + this.config.transform.rotateZ + "deg) "
          + "skewX(" + this.config.transform.skewX + "deg)"
          + "skewY(" + this.config.transform.skewY + "deg)"
        break;
      default:
    }
  }

  /**
   * Hàm cập nhật giá trị transform
   */
  setTransform() {
    this.class['shape__parent'].transform = "rotateX(" + this.config['transform'].rotateX + "deg) "
      + "rotateY(" + this.config['transform'].rotateY + "deg) "
      + "rotateZ(" + this.config['transform'].rotateZ + "deg) "
      + "skewX(" + this.config['transform'].skewX + "deg) "
      + "skewY(" + this.config['transform'].skewY + "deg) ";
  }

  //set border cho class shape__parent
  setBorder() {
    this.class.shape__parent['border-top-left-radius'] = this.class.shape__child['border-top-left-radius'];
    this.class.shape__parent['border-top-right-radius'] = this.class.shape__child['border-top-right-radius'];
    this.class.shape__parent['border-bottom-left-radius'] = this.class.shape__child['border-bottom-left-radius'];
    this.class.shape__parent['border-bottom-right-radius'] = this.class.shape__child['border-bottom-right-radius'];
    this.updateClass();
  }

  /**
  * @param index : vị trí phần tử muốn xóa
  * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  openbgGradient() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('input-gradient').click();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Get class active của element khi click chọn hướng phối màu.
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      var activeGradient = document.querySelector('.active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      if (this.device == 'desktop') {
        this.config['background-color'].gradient_type = direction.type;
        this.config['background-color'].gradient_direction = direction.direction;
        this.class['shape__child']['background'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
        this.updateConfig();
        this.updateClass();
      } else {
        this.config['background-color'].gradient_type = direction.type;
        this.config['background-color'].gradient_direction =
          direction.direction;
        this.updateConfig();
      }
    }
  }
  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['shape__child'].background = "linear-gradient(" + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['shape__child'].background = this.config['background-color'].background;
    }
    this.updateObject();
  }

  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**Xử lý lấy thông số giá trị background gradient
  * @param event : trả về giá trị từ 0-100
  */
  getValueRangeBackgroundGradient(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    if (this.device == 'desktop') {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] =
        this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      // Tách các phần tử màu từ chuỗi rgba.
      const newArr =
        this.config['background-color'].arr_gradient_desktop.map(
          (color) => {
            const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
          }
        );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].arr_gradient_desktop = newArr;
      this.updateBackgroundRgb()
    } else {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] =
        this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      const newArr =
        this.config['background-color'].arr_gradient_mobile.map(
          (color) => {
            // Tách các phần tử màu từ chuỗi rgba
            const parts = color.match(/(\d+(\.\d+)?)/g);
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
          }
        );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].arr_gradient_mobile = newArr;
      this.updateClass()
    }
  }

  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('upload').click();
  }

  //Lưu hình ảnh
  // saveImage() {
  //   this.functionService.createMessage('success', "tai_anh_thanh_cong");
  //   this.updateObject();
  // }
  /**
   * Lấy đường dẫn từ máy
   * @param e Biến lưu hình ảnh
   */
  // onUpload(e) {
  //   const file = e.target.files[0];
  //   if (file) {
  //     this.vhImage.getThumbnailFromDesktop(file, 400, 400, "object-shape", null).then(
  //       (photoURL: any) => {
  //         this.objectChoosing.staticdata.link = photoURL;
  //         // this.class.shape__child['background-color'] = 'none'
  //         this.class.shape__child['background'] = `url('${this.staticdata.link}')`;
  //         this.saveImage();
  //       },
  //       (error) => {

  //         // this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
  //       }
  //     );
  //   }
  //   this.config['background-color']['is_load_image'] = true;
  // }
  onUpload(e) {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      this.processImageUpload(file);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_chon_tep_hinh_anh_hop_le');
        this.config['background-color']['is_load_image'] = true;
        return;
      }
    }
    this.config['background-color']['is_load_image'] = true;
  }

  /**
   * Hàm xử lý khi người dùng kéo và thả (drop) một tệp vào vùng upload.
   * @param event file được kéo vào
   */
  onFileDropped_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files[0];

    if (file && file.type.startsWith('image/')) {
      // Hiển thị preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUploadUrl = reader.result as string;
      };
      reader.readAsDataURL(file);

      // Xử lý tệp hình ảnh
      this.processImageUpload(file);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
        return;
      }
    }
  }

  /**
   * Hàm xử lý tệp hình ảnh lên server 
   * - Tải lên
   * - Kéo thả vào
   * 
   * Nén ảnh:
   * - 'no-compress': Không nén ảnh sau khi tải lên
   * - 'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
   * - 'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
   * @param file File được kéo thả vào hoặc được tải lên
   */
  processImageUpload(file: File) {
    let compress_type = this.objectChoosing.setups?.upload_image.compress_type;
    let resolution = {};
    switch (compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        const dimension = this.objectChoosing[`${this.device}_config`]?.dimension;
        if (
          dimension && 
          Object.keys(dimension).length > 0 &&
          typeof dimension.width === 'number' &&
          typeof dimension.height === 'number'
        ) {
          resolution = {
            width: dimension.width,
            height: dimension.height,
          };
        }
        else {
          const deviceItem = this.functionService.devices.find((device) => device.value == this.device);
          resolution = {
            width: deviceItem.width,
            height: deviceItem.height,
          };
        }
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        };
        compress_type = 'compress-frame';
        break;
    }
  
    this.vhImage
      .getImageFromDesktop_Autoweb(file, 'images/design/objects', {
        compress_type: compress_type,
        resolution: resolution,
      })
      .then((res: any) => {
        if (res.vcode != 0) {
          this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${res.msg}`);
          return;
        } else {
          this.functionService.createMessage('success', 'tai_anh_thanh_cong');
        }
  
        this.config['background_image_restore']  = res.data;
        this.updateBackgroundImageRestore({ value: res.data });
        this.handleSetBackgroundImage();
      });
  }

  /**
   * Hàm thực hiện gán giá trị cho 5 thiết bị hoặc thiết bị hiện tại (Chỉ dùng cho config)
   */
  updateBackgroundImageRestore({
    varField = 'background_image_restore',
    value,
  }: {
    varField?: string; // tên trường truyền về
    value?: any;
  } = {}) {
    const applyUpdate = (device: string) => this.objectChoosing[device + '_config'][varField] = value;

    if (this.objectChoosing.setups.upload_image.display === 'shared') {
      this.functionService.devices.forEach(device => applyUpdate(device.value));
    } else {
      applyUpdate(this.device);
    }
  }

  /** Hàm thực hiện gán giá trị background-image khi có thay đổi
   *
   */
  handleSetBackgroundImage() {
    this.class['shape__child']['background'] = `url("${this.config['background_image_restore']}")`;
    if (this.objectChoosing.setups.upload_image.display === 'shared') {
      this.functionService.devices.forEach(device => {
        this.updateDisplaySharedClass(device.value);
        this.updateDisplaySharedConfig(device.value);
      });
    }
    else {
      this.updateConfig();
      this.updateClass();
    }
    this.updateSetups();
  }

  //Hàm xử lý boxShadow của clip-path
  boxShadow() {
    var config = this.config['box-shadow'];
    this.class.shape.filter = "drop-shadow(" + config.offset_x + 'px ' + config.offset_y + 'px ' + config.blur_radius + 'px ' + config.shadow_color + ")";
    // this.updateObject();
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['shape']['width'] = event.width + 'px';
    if (event.height) this.class['shape']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  path = '/images';
  openLibrary() {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        this.config['background_image_restore'] = data.href;
        this.handleSetBackgroundImage();
        this.functionService.createMessage('success', "tai_anh_thanh_cong");
      }
      this.path = data.path;
    });
  }


  /**
   * Cập nhật kiểu background, khi chuyển từ ảnh sang màu thì set màu mặc định
   */
  updateBgCheck() {
    if (this.config['background-color']['bg_check'] === 'color') {
      this.config.background_color_restore = 'rgb(77, 138, 198)';
      this.class['shape__child']['background'] = this.config.background_color_restore;
      this.updateClass();
      this.updateConfig();
    } else if (this.config['background-color']['bg_check'] === 'image') {
      if (!this.config.background_image_restore || this.config.background_image_restore === '')
        this.config.background_image_restore = "https://img.freepik.com/free-vector/white-abstract-background-design_23-2148825582.jpg?w=1380&t=st=1697510003~exp=1697510603~hmac=4c547175bf91f9c5d38fc8107e6ca7f50fcb185bf867a4b163a257d7b87b39c4";
      this.class['shape__child']['background'] = 'url(' + this.config.background_image_restore + ')';
      this.updateClass();
      this.updateConfig();
    }
  }

  onRadiusChange(position: string, value: any): void {
    const num = Math.max(0, Math.min(100, Number(value)));
    this.class.shape__child[position] = `${num}px`;
  }

  onRadiusBlur(position: string, value: string): void {
    let num = parseInt(value || '0', 10);
    num = isNaN(num) ? 0 : Math.max(0, Math.min(100, num));
    this.class.shape__child[position] = `${num}px`;
    this.setBorder();
  }

  /**
   * Hành động khi người dùng kéo file qua vùng upload (chưa thả).
   * @param event 
   */
  onDragOver_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  /**
   * Hành động khi người dùng rời con trỏ khỏi vùng upload mà chưa thả.
   */
  onDragLeave_upload() {
    this.dragging = false;
  }

  /**
   * Kiểm tra nếu chuỗi là màu hợp lệ (hex, rgb, rgba)
   * @param colorString Chuỗi màu cần kiểm tra
   * @returns boolean Trả về true nếu là màu hợp lệ
   */
  isValidColor(colorString: string): boolean {
    // Kiểm tra màu hex (3 hoặc 6 ký tự, có hoặc không có #)
    const hexRegex = /^#([A-Fa-f0-9]{3}){1,2}$/;
    if (hexRegex.test(colorString)) {
      return true;
    }

    // Kiểm tra màu rgb/rgba
    const rgbRegex = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/;
    const rgbaRegex = /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(0|1|0?\.\d+)\)$/;
    
    if (rgbRegex.test(colorString) || rgbaRegex.test(colorString)) {
      // Kiểm tra giá trị RGB từ 0-255
      const match = colorString.match(/(\d{1,3})/g);
      if (match) {
        const [r, g, b] = match.map(Number);
        return [r, g, b].every(val => val >= 0 && val <= 255);
      }
    }

    return false;
  }

  /**
   * Cập nhật Setups vào database.
   */
  updateSetups() {    
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { setups: this.objectChoosing.setups, })
      .then((bool: any) => {
        if(this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
          // nếu là frame-blank con của banner thì bắn sự kiện frame-banner set lại z-index frame-blank con
          // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
          this.vhEventMediator.notifyOnConfigChanged({
            status: 'config-changed', 
            code: this.objectChoosing.id_object, 
          });
        }
      });
  }

  //Hàm update display shared config
  updateDisplaySharedConfig(device: string) {
    const config = {
      [device + '_config']: {
        ...this.objectChoosing[device + '_config'],
        background_image_restore: this.config.background_image_restore,
      },
    };

    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, config)
      .then((bool: any) => {
        if(this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
          // nếu là frame-blank con của banner thì bắn sự kiện frame-banner set lại z-index frame-blank con
          // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
          this.vhEventMediator.notifyOnConfigChanged({
            status: 'config-changed', 
            code: this.objectChoosing.id_object, 
          });
        }
      });
  }

  //Hàm update display shared class
  updateDisplaySharedClass(device: string) {
    const update = {
      [device + '_class']: {
        ...this.objectChoosing[device + '_class'],
        'shape__child': {
          ...this.objectChoosing[device + '_class'].shape__child,
          'background-image': this.class.shape__child['background-image'],
        },
      },
    };

    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, update)
      .then((bool: any) => {
        if(this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
          // nếu là frame-blank con của banner thì bắn sự kiện frame-banner set lại z-index frame-blank con
          // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
          this.vhEventMediator.notifyOnConfigChanged({
            status: 'config-changed', 
            code: this.objectChoosing.id_object, 
          });
        }
      });
  }

  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openEditShape() {
    const dialogRef = this.matDialog.open(EditShapeComponent, {
      width: '80vw',
      height: '90vh',
      data: {
        clipPath: this.class.shape__parent['clip-path'],
        optionDisplay: this.config.switch_color ? 'color' : 'image',
        bgImage: this.config.background_image_restore,
        bgColor: this.class.shape__child['background'],
        clipPathsList: this.clipPaths,
      },
    });

    dialogRef.afterClosed().subscribe((clipPath) => {
      if (clipPath) {
        this.class.shape__parent['clip-path'] = clipPath;
        this.class.shape__child['clip-path'] = clipPath;
        this.updateClass();
      }
    });
  }
}
